// External Imports
import { useContext, useEffect, useState } from "react";
import { MdLogout } from "react-icons/md";

// Internal Imports
import { AuthContext } from "../../context/auth-context";
import DataContext from "../../context/data-context";
import PoshLogo from "../UI/PoshLogo";
import CheckOnline from "../UI/CheckOnline";

/** ========================================================================
 * * Navbar Component
 * This component renders the navigation bar at the top of the app.
 * ========================================================================== */

export default function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const { partner } = useContext(DataContext);

  return (
    <header className="z-20">
      <CheckOnline />

      <div className="mx-6 md:mx-12">
        <div className="flex items-center justify-between py-4 lg:py-6">
          <div className="flex items-end justify-start space-x-4">
            <PoshLogo />
            <p className="text-2xl md:text-3xl font-extralight text-stone-400">
              Partner <span className="text-xs">v1.2.1</span>
            </p>
          </div>

          <div className="-my-2 md:hidden">
            <div className="flex items-center px-4 py-2 space-x-4 text-center rounded-md h-fit bg-stone-600">
              <MdLogout onClick={() => logout()} className="icon" />
            </div>
          </div>

          
            <div className="items-center justify-end hidden md:flex md:flex-1">
              {user && (
                <div className="flex items-center space-x-4">
                  {partner?.photoURL && (
                    <img src={partner.photoURL} className="w-6 h-6 rounded-full" />
                  )}
                  <p className="text-sm font-semibold text-stone-200">
                    {partner ? partner.name : user.displayName}
                  </p>

                  <div className="flex items-center px-4 py-2 space-x-4 text-center rounded-md h-fit bg-stone-600">
                    <MdLogout onClick={() => logout()} className="icon" />
                  </div>
                </div>
              )}
            </div>
          
        </div>
      </div>
    </header>
  );
}
